import { Body, Icon, IconType } from '@assembly-js/design-system';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import clsx from 'clsx';

export const MenuOption = ({
  icon,
  text,
  onClick,
  isDestructiveAction,
}: {
  icon: IconType;
  text: string;
  onClick: () => void;
  isDestructiveAction?: boolean;
}) => (
  <MenuItem classes={{ root: 'px-3 py-0.5' }} onClick={onClick}>
    <ListItemIcon classes={{ root: 'mr-3' }}>
      <Icon
        icon={icon}
        className={clsx(
          'w-[13px] h-[13px]',
          isDestructiveAction ? 'text-error-primary' : 'text-black-heading',
        )}
      />
    </ListItemIcon>
    <ListItemText>
      <Body
        className={clsx(
          isDestructiveAction ? 'text-error-primary' : 'text-black-heading',
        )}
      >
        {text}
      </Body>
    </ListItemText>
  </MenuItem>
);
